import {Component, effect, ElementRef, HostListener, inject, signal, ViewChild} from '@angular/core';
import {MenuService} from '../../../core/services/menu.service';
import {Router} from '@angular/router';
import {CommonModule} from '@angular/common';
import {CommandPaletteService} from '../../services/command-palette.service';
import {MenuItem} from 'primeng/api';

@Component({
  selector: 'app-command-palette',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './command-palette.html',
  styleUrl: './command-palette.scss',
})
export class CommandPalette {
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;
  private menuService = inject(MenuService);
  private router = inject(Router);
  paletteService = inject(CommandPaletteService);

  results =  signal<MenuItem[]>([]);
  selectedIndex = signal<number>(-1);

  constructor() {
    effect(() => {
      if (this.paletteService.visible()) {
        // Se espera al siguiente ciclo del DOM para habilitar el focus
        queueMicrotask(() => {
          this.searchInput?.nativeElement.focus();
        });
      }
    });
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboard(event: KeyboardEvent) {
    // Abrir
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'k') {
      event.preventDefault();
      this.paletteService.open();
      return;
    }
    // Cerrar
    if (event.key === 'Escape') {
      this.paletteService.close();
      this.results.set([]);
      this.selectedIndex.set(-1);
      return;
    }

    // si no está visible, no hacer nada
    if (!this.paletteService.visible()) return;

    const results = this.results();
    if (!results.length) return;
    // Flecha abajo
    if (event.key === 'ArrowDown') {
      console.log(event.key);
      event.preventDefault();
      this.selectedIndex.update(i => (i + 1) % results.length);
    }

    // Flecha arriba
    if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.selectedIndex.update(i => (i - 1 + results.length) % results.length);
    }

    // Enter
    if (event.key === 'Enter') {
      event.preventDefault();
      const index = this.selectedIndex();
      if (index >= 0) {
        this.navigate(results[index]);
      }
    }
  }

  closePalette() {
    this.paletteService.close();
    this.results.set([]);
    this.selectedIndex.set(-1);
  }

  search(value: string) {
    this.results.set(this.menuService.searchMenu(value));
    this.selectedIndex.set(this.results().length ? 0 : -1);
  }

  navigate(item: MenuItem) {
    if (item["route"]) {
      this.router.navigate([item["route"]]);
      this.paletteService.close();
      this.results.set([]);
    }
  }
}
